module.exports = __webpack_public_path__ + "static/media/scratch-logo.3769fe2d.svg";